import { render, staticRenderFns } from "./ProductDetailView.vue?vue&type=template&id=492e27aa&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailView.vue?vue&type=style&index=0&id=492e27aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e27aa",
  null
  
)

export default component.exports